<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>Value Input</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-form v-model="valid">
                <div class="pa-0 ma-0" v-if="!category">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field
                                v-model="item.name"
                                hide-details
                                prepend-icon="mdi-hammer-wrench"
                                label="Name *"
                                :rules="[rules.required]"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="4">
                            <v-text-field
                                v-model="item.value"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Value *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="item.weight" class="mx-2">
                            <v-text-field
                                v-model="item.weight"
                                hide-details
                                prepend-icon="mdi-weight"
                                label="Weight (kg) *"
                                type="number"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div class="pa-0 ma-0" v-else-if="category == MINERAL_WOOD">
                    <v-row no-gutters class="my-4">
                        <v-col cols="12">
                            <v-text-field
                                v-model="item.reference"
                                hide-details
                                prepend-icon="mdi-hammer-wrench"
                                label="Name *"
                                :rules="[rules.required]"
                                disabled
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="my-4">
                        <v-col cols="4">
                            <v-text-field
                                v-model="item.inches"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Inches *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="item.price"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Price *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div
                    class="pa-0 ma-0"
                    v-else-if="category == PREPEINTED_ALUMINUM_SHEET"
                >
                    <v-row no-gutters class="my-4">
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.length"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Length *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.thickness"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Thickness *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="my-4">
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.value"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Price *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.width"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Width *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div
                    class="pa-0 ma-0"
                    v-else-if="category == INDUSTRIAL_MATERIALS"
                >
                    <v-row no-gutters class="my-4">
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.length"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Length *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.width"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Width *"
                                type="number"
                                :rules="[rules.required, rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="item.thickness"
                                hide-details
                                prepend-icon="mdi-counter"
                                label="Thickness "
                                type="number"
                                :rules="[rules.number]"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                v-if="!category"
                color="primary"
                class="mb-4"
                @click="saveProcess"
                rounded
                :loading="loading"
                :disabled="!valid"
            >
                SAVE
            </v-btn>
            <v-btn
                v-else-if="category == INDUSTRIAL_MATERIALS"
                color="primary"
                class="mb-4"
                @click="updateIndustrialMaterials"
                rounded
                :loading="loading"
                :disabled="!valid"
            >
                SAVE
            </v-btn>
            <v-btn
                v-else
                color="primary"
                class="mb-4"
                @click="updateSpecialItem"
                rounded
                :loading="loading"
                :disabled="!valid"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import { objDiff } from '@/helpers/objDiff.js'
import API from '@/services/api'

export default {
    name: 'ProfileForm',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: () => false,
        },
        setting: {
            type: Object,
            required: true,
        },
        category: {
            type: String,
            default: () => undefined,
        },
        specialItem: {
            type: Object,
            default: () => null,
        },
    },
    data: () => ({
        MINERAL_WOOD: 'mineralWoolItems',
        PREPEINTED_ALUMINUM_SHEET: 'prepeintedAluminumSheetItems',
        INDUSTRIAL_MATERIALS: 'industrialMaterials',
        loading: false,
        rules: {
            required: v => !!v || 'required value',
            number: v => v >= 0 || 'invalid number',
        },
        valid: false,
    }),
    computed: {
        itemDiff: function() {
            if (!this.createForm) {
                return objDiff(this.originalItem, this.item)
            } else {
                return null
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async saveProcess() {
            if (!this.createForm) {
                await this.update()
            }
        },
        async update() {
            try {
                this.loading = true
                if (this.itemDiff.percentage) {
                    delete this.item.currency
                    delete this.item.unit
                }
                const item = await API.updateValueInput({
                    settingId: this.setting.id,
                    id: this.item.id,
                    ...this.itemDiff,
                })
                this.$emit('replaceItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async updateSpecialItem() {
            try {
                this.loading = true
                Object.keys(this.item).forEach(key => {
                    const parameter = Number(this.item[key])
                    if (!isNaN(parameter)) {
                        this.item[key] = parameter
                    }
                })
                this.specialItem.items.splice(
                    this.specialItem.selectedIndex,
                    1,
                    this.item
                )
                const item = await API.updateValueInput({
                    settingId: this.setting.id,
                    id: this.specialItem.id,
                    items: this.specialItem.items,
                })
                this.$emit('replaceSpecialItem', {
                    itemToUpdate: item,
                    containerKey: this.category,
                })
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async updateIndustrialMaterials() {
            try {
                this.loading = true
                Object.keys(this.itemDiff).forEach(key => {
                    const parameter = Number(this.itemDiff[key])
                    if (!isNaN(parameter)) {
                        this.itemDiff[key] = parameter
                    }
                })
                const item = await API.updateValueInput({
                    settingId: this.setting.id,
                    id: this.item.id,
                    ...this.itemDiff,
                })
                this.$emit('replaceIndustrialMaterials', {
                    itemToUpdate: item,
                })
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
